import React, { useState, useContext, useRef, Suspense, useEffect, useCallback } from "react"
import { Canvas } from "react-three-fiber"
import { Map } from "./Map/Map"
import ModalPoint from "./Map/ModalPoint"
import ModalEdge from "./Map/ModalEdge"
import ModalReset from "./Map/ModalReset"
import ModalArea from "./Map/ModalArea"
import ModalMap from "./Map/ModalMap"
import ModalDelete from "./Map/ModalDelete"
import Context from "../../utils/Context"
import { sendTaskToRobot, cancelActions, sendNavInfo, watchRobotPosition } from "../../utils/ROS/ROSFunctions"
import Joystick from "../../components/Joystick"
import OccupancyGridVisualizer from "./Map/OccupancyGridVisualizer"
import ROS from "../../utils/ROS/ROS"
import api from "../../api/api"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSave, faSpinner, faLocationArrow, faUndo, faRetweet, faCirclePlus, faMapMarked, faCheck, faTrash, faBan, faVectorSquare, faReply, faShare, faMapPin, faMapSigns, faArrowPointer } from "@fortawesome/free-solid-svg-icons"
import ShowMessage from "../../components/ShowMessage"
import CompareArray from "../../components/elements/CompareArray"

export default function Maps() {
  const context = useContext(Context)
  const canvasRef = useRef()
  const modalRef = useRef()
  const orientation = context.orientation
  const [mapping, setMapping] = useState((context.mappingCurrent) ? context.mappingCurrent : [])
  const [modal, setModal] = useState(false)
  const [typeMap, setTypeMap] = useState(false)
  const [modalData, setModalData] = useState(null)
  const [isMapping, setIsMapping] = useState(false)
  const [hand, setHand] = useState(false)
  const [canvas, setCanvas] = useState(null)
  const [autoSave, setAutoSave] = useState(false)

  const c = console.log.bind(document)

  useEffect(() => {
    selectTool('select')
    /*const index = 0
    console.log(c)
    let maps = context.maps.map(m => m.robotId === context.robotInfo._id && m.name === map.name ?
      ({ ...m, active: true })
      : m.robotId === context.robotInfo._id ?
        ({ ...m, active: false })
        :
        (m))

    const map = maps[index]
    console.log(index, map)
    context.actions.setMapIndex(index)
    context.actions.setSelected({ map: { name: map.name, robotId: context.robotInfo._id } })
    context.actions.setHelpers({ ...context.helpers, newItem: true })
    setIsMapping((context.mappingCurrent && context.mappingCurrent.name === map.name) ? context.mappingCurrent?.mapping : false)
    context.actions.setMapObjects(map.objects ? map.objects : {})

    console.log(maps)
    //context.actions.setMaps(maps)*/
  }, [])

  useEffect(() => {
    if (context.endOfMission && context.lastMission === 'map') {
      //exportMaps()
    }
  }, [context.endOfMission])

  useEffect(() => {
    if (autoSave) {
      exportMaps()
    }
  }, [context.changes, autoSave])

  // process mapping feeback --------------------------------------

  useEffect(() => {
    if (context.mappingStatus) {
      setMapping((context.mappingCurrent) ? context.mappingCurrent : mapping)
      setIsMapping((context.mappingCurrent) ? context.mappingCurrent.mapping : false)
    }
  }, [context.mappingStatus])

  // validate nav point name ----------------------------------------------------------------------------

  const savePoint = async () => {
    if (context.selected.tool?._id === 'points') {
      const filtered = context.mapObjects.points?.filter(p => p.name?.indexOf(n => n === modalData.name) > -1)
      console.log('finding point name', filtered, context.mapObjects.points, modalData?.name)

      if (!modalData?.name || (modalData?.name && modalData.name.length < 0)) {
        context.actions.setMessage({ message: "Please add an ID", type: "error" })
        return false

      } else if (filtered.length > 1) {
        context.actions.setMessage({ message: "This ID is already in use", type: "error" })
        return false
      }
    }

    // reset newObject
    if (context.helpers.newObject) context.actions.setHelpers({ ...context.helpers, newObject: false })

    setModalData(null)

    setModal(false)
    context.actions.setMessage({ message: "There are unsaved items", type: "error" })
  }

  // open modals -----------------------------------------------------------

  const openModal = (modalType, data) => {
    if (data) setModalData(data)

    if (modalType) setModal(modalType)

  }

  const locateRobot = () => {
    // (context)
    selectTool('location')
    //setModal('location')
  }

  // convert nav info format -----------------------------------------------

  const convertNavInfo = useCallback((newObjects) => {

    let objects

    if (newObjects) {
      objects = newObjects
    } else {
      objects = context.mapObjects
    }

    let navInfo = { points: [], edges: [], zones: [], no_go: [], map_name: context.selected.map?.name }

    console.log("filling nav info", objects)
    console.log("nav info map name", context.selected.map?.name)

    // fill points info
    Array.isArray(objects.points) && objects.points.forEach(point => {
      navInfo.points.push({ id: point.name, point: point.point })
    })

    // fill edges info
    let fromPoint, toPoint
    Array.isArray(objects.edges) && Array.isArray(objects.points) && objects.edges.forEach(item => {
      fromPoint = objects.points.find(p => p.name.indexOf(item.from) > -1)
      toPoint = objects.points.find(p => p.name.indexOf(item.to) > -1)
      if (fromPoint?.point) fromPoint = fromPoint.point
      if (toPoint?.point) toPoint = toPoint.point
      if (fromPoint && toPoint) {
        const distance = Math.sqrt(Math.pow((toPoint.x - fromPoint.x), 2) + Math.pow((toPoint.y - fromPoint.y), 2))
        navInfo.edges.push({ id1: item.from, id2: item.to, distance: distance, avoid: item.avoid, reversable: item.reversable })
      }
    })

    // fill zones info
    let zone
    Array.isArray(objects.areas) && objects.areas.forEach(item => {
      zone = { name: item.name, polygon: [], max_velocity: item.velocity ? item.velocity : false, beep: item.beep ? item.beep : false }
      Array.isArray(item.polygon) && item.polygon.forEach((point, i) => {
        if (i < item.polygon.length)
          zone.polygon.push(point.point)
      })
      navInfo.zones.push(zone)
    })

    // fill no_go info
    Array.isArray(objects.no_go) && objects.no_go.forEach(item => {
      zone = { polygon: [] }
      Array.isArray(item.polygon) && item.polygon.forEach(point => {
        zone.polygon.push(point.point)
      })
      navInfo.no_go.push(zone)
    })

    return navInfo
  }, [context.selected])

  const calculateAreaRotation = (angle, x, y, width, height) => {
    let points = [{ x: x, y: y }, { x: x + width, y: y }, { x: x + width, y: y + height }, { x: x, y: y + height }]

    let angleRadian = (angle * Math.PI) / 180

    points[1].x = x + Math.cos(angleRadian) * width
    points[1].y = y - Math.sin(angleRadian) * width

    points[2].x = x + Math.cos(angleRadian) * width + Math.sin(angleRadian) * height
    points[2].y = y - Math.sin(angleRadian) * width + Math.cos(angleRadian) * height

    points[3].x = x + Math.sin(angleRadian) * height
    points[3].y = y + Math.cos(angleRadian) * height

    return points
  }

  // save map --------------------------------------------------------------

  const save = () => {
    let maps = [...context.maps]
    console.log(context.maps)
    const currentMap = context.maps.find(m => m.name === context.selected.map?.name)
    validateArea()
    console.log(context.konvaPoints, context.konvaEdges, context.mapObjects, currentMap)
    let newObjects = {}
    let noGoPoints = []
    //let slowPoints = []

    context.konvaPoints.length !== 0 && context.konvaPoints.forEach((point, i) => {
      if (i === 0) newObjects.points = []
      switch (point.fill) {
        case 'blue':
          newObjects.points.push({ counter: 'pn-' + (i + 1), name: [point.name], point: { x: point.x * currentMap.resolution + currentMap.origin.x, y: -(point.y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } })
          break

        case 'red':
          noGoPoints.push({ counter: 'pf-' + (i + 1), name: point.name, point: { x: point.x * currentMap.resolution + currentMap.origin.x, y: -(point.y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } })
          break

        default:
          break
      }
    })

    let noGoAdjacency = {}
    //let slowAdjacency = {}
    let noGoEdges = new Set()
    //let slowEdges = new Set()

    context.konvaEdges.length !== 0 && context.konvaEdges.forEach((edge, i) => {
      if (i === 0) newObjects.edges = []
      let pointA = edge.pointIds[0]
      let pointB = edge.pointIds[1]
      let reverse = true
      if (edge.pointerAtEnding) {
        reverse = false
      }
      if (edge.pointerAtBeginning) {
        reverse = false
        pointA = edge.pointIds[1]
        pointB = edge.pointIds[0]
      }

      switch (edge.stroke) {
        case 'purple':
          newObjects.edges.push({ avoid: true, counter: 'ln-' + (i + 1), from: pointA, reversable: reverse, to: pointB })
          break

        case 'blue':
          newObjects.edges.push({ avoid: false, counter: 'ln-' + (i + 1), from: pointA, reversable: reverse, to: pointB })
          break

        case 'red':
          if (!noGoAdjacency[pointA]) noGoAdjacency[pointA] = []
          if (!noGoAdjacency[pointB]) noGoAdjacency[pointB] = []
          noGoAdjacency[pointA].push(pointB)
          noGoAdjacency[pointB].push(pointA)
          break

        default:
          break
      }
    })

    console.log(noGoPoints, noGoAdjacency)
    let noGoPolygons = []
    context.konvaEdges.length !== 0 && context.konvaEdges.forEach((edge) => {
      let pointA = edge.pointIds[0]
      let pointB = edge.pointIds[1]

      if (edge.stroke === 'red') {
        if (!noGoEdges.has(edgeKey(pointA, pointB))) {
          const polygon = tracePolygon(pointA, noGoEdges, noGoAdjacency)

          noGoPolygons.push(polygon)
        }
      }
    })

    console.log(context.konvaPoints, noGoPoints)

    let finalNoGo = noGoPolygons.map((polygon) => {
      let corners = polygon.map((corner) => {
        let correctCorner = noGoPoints.find((point) => corner === point.name || point.name.includes(corner))
        return { counter: correctCorner.counter, point: correctCorner.point }
      })

      return { polygon: corners }
    })

    console.log(finalNoGo)

    if (finalNoGo.length !== 0) newObjects.no_go = finalNoGo

    context.konvaAreas.length !== 0 && context.konvaAreas.forEach((area, i) => {
      if (i === 0) newObjects.areas = []
      let beep

      switch (area.stroke) {
        case 'orange':
          beep = false
          break

        case 'hotpink':
          beep = true
          break

        default:
          break
      }

      if (area.rotation === 0) {
        newObjects.areas.push({
          velocity: area.velocity,
          beep: beep,
          name: area.name,
          polygon: [
            { counter: 'pz1-' + (i + 1), point: { x: area.x * currentMap.resolution + currentMap.origin.x, y: -(area.y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } },
            { counter: 'pz2-' + (i + 1), point: { x: (area.x + area.width * area.scaleX) * currentMap.resolution + currentMap.origin.x, y: -(area.y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } },
            { counter: 'pz3-' + (i + 1), point: { x: (area.x + area.width * area.scaleX) * currentMap.resolution + currentMap.origin.x, y: -((area.y + area.height * area.scaleY) - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } },
            { counter: 'pz4-' + (i + 1), point: { x: area.x * currentMap.resolution + currentMap.origin.x, y: -((area.y + area.height * area.scaleY) - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } }
          ]
        })
      } else {
        let fourPoints = calculateAreaRotation(area.rotation, area.x, area.y, area.width * area.scaleX, area.height * area.scaleY)

        newObjects.areas.push({
          velocity: area.velocity,
          beep: beep,
          name: area.name,
          polygon: [
            { counter: 'pz1-' + (i + 1), point: { x: area.x * currentMap.resolution + currentMap.origin.x, y: -(area.y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } },
            { counter: 'pz2-' + (i + 1), point: { x: fourPoints[1].x * currentMap.resolution + currentMap.origin.x, y: -(fourPoints[1].y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } },
            { counter: 'pz3-' + (i + 1), point: { x: fourPoints[2].x * currentMap.resolution + currentMap.origin.x, y: -(fourPoints[2].y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } },
            { counter: 'pz4-' + (i + 1), point: { x: fourPoints[3].x * currentMap.resolution + currentMap.origin.x, y: -(fourPoints[3].y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } }
          ]
        })
      }
    })

    console.log(newObjects, context.mapObjects)

    const newMap = { ...context.maps[context.mapIndex], objects: newObjects }
    maps[context.mapIndex] = newMap
    context.actions.setMapObjects(newObjects)
    console.log(context.maps, maps)
    context.actions.setMaps(maps)

    sendNavInfo(convertNavInfo(newObjects), context.selectedRobot.ROS)
    context.actions.setMessage({ message: "Saved", type: "success" })
  }

  // save map name ----------------------------------------------------------

  const saveMap = async () => {

    if (!modalData?.mapName || modalData?.mapName === "") {
      context.actions.setMessage({ message: "Please fill map name", type: "error" })
      return false
    }

    const searchMap = context.maps.find(m => m.name?.toLowerCase() === modalData.mapName?.toLowerCase() && m.robotId === context.robotInfo._id)
    if (searchMap) {
      context.actions.setMessage({ message: "Map already exists", type: "error" })
      return false
    }

    if (~modalData?.mapName.indexOf('.') || ~modalData?.mapName.indexOf('/') || ~modalData?.mapName.indexOf('\\') || ~modalData?.mapName.indexOf(';') || ~modalData?.mapName.indexOf(':')) {
      context.actions.setMessage({ message: "Please not fill map name with points, slash or backslash", type: "error" })
      return false
    }


    context.actions.setMapObjects({})

    let maps, mapId

    // send map item to FMS
    if (context.settings.fmsConnection) {

      const mapIndex = context.maps.length - 1
      context.actions.setMapIndex(mapIndex)
      maps = context.maps.map(m => m.robotId === context.robotInfo._id ? ({ ...m, active: false }) : m)
      mapId = null

      if (!context.robotInfo) {
        context.actions.setMessage({ message: "Robot not registered on FMS. Please register it with the official name.", type: "error" })
        return false
      }

      console.log(modalData, context.selectedRobot, typeMap, context.mapFeedFull)
      context.actions.setMaps([...maps, { name: modalData.mapName, robot: context.selectedRobot.name, robotId: context.robotInfo._id, active: true, _id: mapId, link: '/maps/' + modalData.mapName + '.png' }])
      context.actions.setMappingCurrent({ name: modalData.mapName, robot: context.selectedRobot.name, robotId: context.robotInfo._id, mapping: isMapping })
      if (context.selectedRobot.ROS === 'ROS2') {
        sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: modalData.mapName, needs_value: false }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
      } else {
        sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: modalData.mapName, needsValue: false }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
      }
      context.actions.setSelected({ map: { name: modalData.mapName, robotId: context.robotInfo._id } })
      setModal(null)
    } else {
      context.actions.setMapIndex(0)

      console.log(modalData, context.selectedRobot, typeMap, context.mapFeedFull)
      context.actions.setMaps([{ name: modalData.mapName, _id: 1, objects: {}, link: '/maps/' + modalData.mapName + '.png' }])
      context.actions.setMappingCurrent({ name: modalData.mapName, robot: context.selectedRobot.name, mapping: isMapping })
      if (context.selectedRobot.ROS === 'ROS2') {
        sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: modalData.mapName, needs_value: false }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
      } else {
        sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: modalData.mapName, needsValue: false }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
      }
      context.actions.setSelected({ map: { name: modalData.mapName } })
      setModal(null)
    }

    // subscribe to map
    if (canvas) {
      console.log("subscribing to map")
      window.mapSubscriber = ROS.subscribeMap(callback, canvas, context, false)
    }
  }


  const getMapOccurrence = (maps, value) => {
    var count = maps.filter((e) => (e.name === value && e.robot === context.robotInfo.name)).length
    var mapsPosition
    var qtd = []

    console.log(count, maps)

    if (count > 1) {
      let newMaps = maps

      newMaps.splice(newMaps.indexOf(value))
      context.actions.setMaps(newMaps)

    } else {
      return true
    }

  }

  // sync fms --------------------------------------------------------------

  const exportMaps = async () => {
    let maps = [...context.maps]
    const currentMap = context.maps.find(m => m.name === context.selected.map?.name)
    validateArea()
    console.log(context.konvaPoints, context.konvaEdges, context.mapObjects, currentMap)
    let newObjects = {}
    let noGoPoints = []
    //let slowPoints = []

    context.konvaPoints.length !== 0 && context.konvaPoints.forEach((point, i) => {
      if (i === 0) newObjects.points = []
      switch (point.fill) {
        case 'blue':
          newObjects.points.push({ counter: 'pn-' + (i + 1), name: [point.name], point: { x: point.x * currentMap.resolution + currentMap.origin.x, y: -(point.y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } })
          break

        case 'red':
          noGoPoints.push({ counter: 'pf-' + (i + 1), name: point.name, point: { x: point.x * currentMap.resolution + currentMap.origin.x, y: -(point.y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } })
          break

        default:
          break
      }
    })

    let noGoAdjacency = {}
    //let slowAdjacency = {}
    let noGoEdges = new Set()
    //let slowEdges = new Set()

    context.konvaEdges.length !== 0 && context.konvaEdges.forEach((edge, i) => {
      if (i === 0) newObjects.edges = []
      let pointA = edge.pointIds[0]
      let pointB = edge.pointIds[1]
      let reverse = true
      if (edge.pointerAtEnding) {
        reverse = false
      }
      if (edge.pointerAtBeginning) {
        reverse = false
        pointA = edge.pointIds[1]
        pointB = edge.pointIds[0]
      }

      switch (edge.stroke) {
        case 'purple':
          newObjects.edges.push({ avoid: true, counter: 'ln-' + (i + 1), from: pointA, reversable: reverse, to: pointB })
          break

        case 'blue':
          newObjects.edges.push({ avoid: false, counter: 'ln-' + (i + 1), from: pointA, reversable: reverse, to: pointB })
          break

        case 'red':
          if (!noGoAdjacency[pointA]) noGoAdjacency[pointA] = []
          if (!noGoAdjacency[pointB]) noGoAdjacency[pointB] = []
          noGoAdjacency[pointA].push(pointB)
          noGoAdjacency[pointB].push(pointA)
          break

        default:
          break
      }
    })

    console.log(noGoPoints, noGoAdjacency)
    let noGoPolygons = []
    context.konvaEdges.length !== 0 && context.konvaEdges.forEach((edge) => {
      let pointA = edge.pointIds[0]
      let pointB = edge.pointIds[1]

      if (edge.stroke === 'red') {
        if (!noGoEdges.has(edgeKey(pointA, pointB))) {
          const polygon = tracePolygon(pointA, noGoEdges, noGoAdjacency)

          noGoPolygons.push(polygon)
        }
      }
    })

    console.log(context.konvaPoints, noGoPoints)

    let finalNoGo = noGoPolygons.map((polygon) => {
      let corners = polygon.map((corner) => {
        let correctCorner = noGoPoints.find((point) => corner === point.name || point.name.includes(corner))
        return { counter: correctCorner.counter, point: correctCorner.point }
      })

      return { polygon: corners }
    })

    console.log(finalNoGo)

    if (finalNoGo.length !== 0) newObjects.no_go = finalNoGo

    context.konvaAreas.length !== 0 && context.konvaAreas.forEach((area, i) => {
      if (i === 0) newObjects.areas = []
      let beep

      switch (area.stroke) {
        case 'orange':
          beep = false
          break

        case 'hotpink':
          beep = true
          break

        default:
          break
      }

      newObjects.areas.push({
        velocity: area.velocity,
        beep: beep,
        name: area.name,
        polygon: [
          { counter: 'pz1-' + (i + 1), point: { x: area.x * currentMap.resolution + currentMap.origin.x, y: -(area.y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } },
          { counter: 'pz2-' + (i + 1), point: { x: (area.x + area.width * area.scaleX) * currentMap.resolution + currentMap.origin.x, y: -(area.y - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } },
          { counter: 'pz3-' + (i + 1), point: { x: (area.x + area.width * area.scaleX) * currentMap.resolution + currentMap.origin.x, y: -((area.y + area.height * area.scaleY) - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } },
          { counter: 'pz4-' + (i + 1), point: { x: area.x * currentMap.resolution + currentMap.origin.x, y: -((area.y + area.height * area.scaleY) - context.mapDimensions.height) * currentMap.resolution + currentMap.origin.y, z: 2 } }
        ]
      })
    })

    console.log(newObjects, context.mapObjects, context.mapIndex)

    var index = maps.findIndex((e) => e.name === context.selected?.map?.name && e.robotId === context.selected?.map?.robotId)

    console.log(index)

    const newMap = { ...context.maps[index], objects: newObjects }
    maps[index] = newMap
    context.actions.setMapObjects(newObjects)
    console.log(context.maps, maps)
    context.actions.setMaps(maps)

    if (context.diagnosticSwitch)
      c("DBug: exportMaps - map selected ", context.selected)

    if (!context.robotInfo) {
      context.actions.setMessage({ message: "Robot not registered on FMS. Please register it with the official name.", type: "error" })
      return false
    }

    if (context.settings.fmsConnection) {

      console.log(maps)

      getMapOccurrence(maps, context.selected.map.name)

      var mapId, respMap

      console.log(context.selected.map)



      if (index || index === 0) {
        if (!maps[index]?._id) {

          console.log(context.mapFeedFull)
          //NEW MAP

          if (context.diagnosticSwitch)
            c("ExportMaps - New Map: ", "name: ", context.selected.map.name, " owner: ", context.robotInfo.owner, "robotId:", context.robotInfo._id, "areaId: ", context.robotInfo.areaId, "origin: ", context.mapFeedFull.origin.position, "objects: ", newObjects, "resolution: ", context.mapFeedFull.resolution)

          try {
            respMap = await api.saveMap({ name: context.selected.map.name, owner: context.robotInfo.owner, robotId: context.robotInfo._id, areaId: context.robotInfo.areaId, origin: context.mapFeedFull.origin.position, resolution: context.mapFeedFull.resolution, objects: newObjects, syncFMS: true })

            c("** RespMAP ", respMap)
            if (!respMap || respMap.status === 401) {
              context.actions.setMessage({ message: "Error to export, try again or reconnect to login", type: "error" })
              return false
            }

            mapId = respMap.data._id

            if (context.diagnosticSwitch)
              c("ExportMaps - New Map: ", "New Index: ", mapId)

            if (respMap) context.actions.setMessage({ message: "Export to success", type: "success" })

          } catch (error) {
            context.actions.setMessage({ message: "Error to export", type: "error" })
            console.log("Error", error)
          }

          if (mapId) {
            //let newMaps = maps.splice(index, 1, Object.assign({}, maps[index], { _id: mapId }));
            if (context.diagnosticSwitch)
              c("ExportMaps - New Map: ", "Add ID: ", mapId)
            let newMaps = [...maps]

            if (context.diagnosticSwitch)
              c("ExportMaps - New Map: ", "Map array: ", newMaps)

            newMaps[index]._id = mapId

            if (context.diagnosticSwitch)
              c("ExportMaps - New Map: ", "Map with ID: ", newMaps, " -  Map Update ID: ", newMaps[index]._id)

            context.actions.setMaps(newMaps)
          } else {
            context.actions.setMessage({ message: "No map ID found on FMS", type: "error" })
          }


        } else {
          console.log('updating')
          //UPDATE MAP
          if (context.diagnosticSwitch)
            c("ExportMaps - Update map: name before filtered: ", maps[index])


          let filteredMap = maps[index]
          delete filteredMap.active
          filteredMap.syncFMS = true
          // console.log("updating FMS with map", filteredMap)

          if (context.diagnosticSwitch)
            c("ExportMaps - Update map: map Object to update : ", filteredMap)

          let updateResult = await api.updateMap(filteredMap)
          if (updateResult) context.actions.setMessage({ message: "map update on FMS result", type: "success" })
          else context.actions.setMessage({ message: "map or points not updated on FMS", type: "error" })
          if (context.diagnosticSwitch)
            c("ExportMaps - Update map: Map update on FMS result: ", updateResult)
        }
      } else {
        context.actions.setMessage({ message: "Map not saved, please save gu", type: "error" })
        return false
      }

    } else {

      context.actions.setMessage({ message: "Error: fms Connection is not available, please verify in Settings", type: "error" })
      return false

    }

  }

  // improve map ----------------------------------------------------

  const saveMapImprove = async () => {

    setModal(null)

    if (!context.selected.map) {
      setModalData(false)
      if (context.selectedRobot.ROS === 'ROS2') {
        cancelActions({ stopmapping: true }, context.selectedRobot.ROS)
      } else {
        cancelActions({ stopMapping: true }, context.selectedRobot.ROS)
      }
      context.actions.setSavingStatus(true)
      setIsMapping(!isMapping)
      setTypeMap(false)
      context.actions.setMessage({ message: "Please select available map", type: "error" })
      return false
    }

    //context.actions.setMaps([...maps, { name:  context.selected.map?.name, robot: context.selectedRobot.name, active: true, _id: mapId }])
    context.actions.setMappingCurrent({ name: context.selected.map?.name, robot: context.selectedRobot.name, mapping: isMapping, robotId: context.robotInfo._id })
    sendTaskToRobot({ actions: [{ id: typeMap, name: typeMap, value: context.selected.map?.name }], id: typeMap, name: typeMap }, context.selectedRobot.ROS)
    //context.actions.setSelected({ map: { name: context.selected.map?.name } })

    // subscribe to map
    if (canvas) {
      // console.log("subscribing to map")
      window.mapSubscriber = ROS.subscribeMap(callback, canvas, context, false)
    }
  }

  // select map -----------------------------------------------------

  const selectMap = async (event) => {
    const index = context.maps.findIndex(m => m.name === event.target.value)
    const map = context.maps[index]
    console.log(index, map)
    context.actions.setMapIndex(index)
    context.actions.setSelected({ map: { name: event.target.value, robotId: context.robotInfo._id } })
    context.actions.setHelpers({ ...context.helpers, newItem: true })
    setIsMapping((context.mappingCurrent && context.mappingCurrent.name === event.target.value) ? context.mappingCurrent?.mapping : false)
    context.actions.setMapObjects(map.objects ? map.objects : {})
    context.actions.setChanges([])
    context.actions.setUndone([])

    let maps = context.maps.map(m => m.robotId === context.robotInfo._id && m.name === event.target.value ?
      ({ ...m, active: true })
      : m.robotId === context.robotInfo._id ?
        ({ ...m, active: false })
        :
        (m))

    console.log(maps)
    //context.actions.setMaps(maps)

    if (context.endOfMission) sendTaskToRobot({ actions: [{ id: "select-map", name: "select-map", value: event.target.value }], id: "select-map", name: "select-map" }, context.selectedRobot.ROS)

    // console.log("fms getting map info", context.settings.fmsConnection, map._id)
    // fms sync
    if (context.settings.fmsConnection) {//&& map._id) {
      // update default map on area item on FMS (site and area for the robot must be defined)
      // console.log("updating area map", context.robotInfo.areaId, map._id)

      //#api.updateAreaMap(context.robotInfo.areaId, map._id)

      // retrieve map nav info from fms
      // console.log("selected map target 1", event.target.value)
      //const updatedMap = await api.getMap(event.target.value)
      //const mapsByFMS = await api.fetchMaps()
      // console.log("updated map", updatedMap)

      //var mapsApi = mapsByFMS.data
      //var mapLocal = context.maps

      /****************/
      //const sameMap = (mapsApi, mapLocal) => mapsApi.name === mapLocal.name && mapsApi.robot === mapLocal.robot;

      //var mapsApiDiff = new CompareArray().compareArrays(mapsApi, mapLocal, sameMap);
      //var mapLocalDiff = new CompareArray().compareArrays(mapLocal, mapsApi, sameMap);

      //var result = [...mapsApiDiff, ...mapLocalDiff];

      //console.log("--", result, index)

      /****************/

      //Rollback this value
      /*
            if (Array.isArray(updatedMap.data) && updatedMap.data[0].objects) {
              const newMaps = [...context.maps]
              newMaps[index].objects = updatedMap.data[0].objects
              console.log("retrieved map nav info from fms", updatedMap.data[0].objects)
              
              context.actions.setMaps(newMaps)
            }
            */
    }
  }

  // reset map --------------------------------------------------------------

  const resetMap = () => {
    let newMap = { ...context.maps[context.mapIndex] }
    newMap.objects = {}
    let newMaps = [...context.maps]
    newMaps[context.mapIndex] = newMap
    context.actions.setMapObjects({})
    context.actions.setKonvaPoints([])
    context.actions.setKonvaEdges([])
    context.actions.setKonvaAreas([])
    context.actions.setMaps(newMaps)
    setModal(false)

    console.log(context.maps, newMaps)
    console.log(context.selected, newMap)

    // update map on FMS
    /* if (context.settings.fmsConnection && newMap._id) {
       api.updateMap(newMap)
     }*/
  }

  // update modal data ------------------------------------------------

  const updateModalData = (item, value) => {
    const data = { ...modalData, [item]: value }
    setModalData(data)

    // update point label and area max velocity and beep
    let newObjects = { ...context.mapObjects }

    if (!context.selected.mapObject) return false

    switch (context.selected.mapObject.type) {
      case 'points':
        //  console.log("updating point", context.selected.connect)
        let currentPointName = newObjects.points[context.selected.mapObject.idx].name

        // update existing edges related to the point
        context.mapObjects.edges && context.mapObjects.edges.forEach((e, i) => {
          if (e.from === currentPointName) {
            // console.log("updating edge point from", i, currentPointName, data.name)
            newObjects.edges[i].from = data.name
          }
          if (e.to === currentPointName) {
            //  console.log("updating edge point to", i, currentPointName, data.name)
            newObjects.edges[i].to = data.name
          }
        })

        // update point name
        newObjects.points[context.selected.mapObject.idx].name = data.name
        break
      case 'edges':
        if (context.selected.connect && newObjects.edges) { // edge update
          //  console.log("updating edge", data)
          newObjects.edges[context.selected.mapObject.idx].reversable = data.reversable
          newObjects.edges[context.selected.mapObject.idx].avoid = data.avoid
          break
        }
        break
      case 'areas':
        // console.log("updating area", context.selected.mapObject.idx, data)
        newObjects.areas[context.selected.mapObject.idx].velocity = parseFloat(data.velocity)
        newObjects.areas[context.selected.mapObject.idx].beep = data.beep
        break
      default:
    }

    context.actions.setMapObjects(newObjects)
  }

  // closeModal ------------------------------------------------------------

  const closeModal = () => {
    setModal(false)
    setModalData(false)
    setIsMapping(false)
    setTypeMap(false)

    if (!modalData?.name && (modal === 'points' || modal === 'areas')) undo()

    context.actions.setSelected({ mapObject: null })
    context.actions.setHelpers({ ...context.helpers, editing: false })
  }

  // change hand side -----------------------------------------------------

  const handSelected = () => {
    setHand(!hand)
  }

  // change hand on orientation ------------------------------------------
  /*
    useEffect(() => {
      (orientation) ? setHand(true) : setHand(false)
    }, [orientation])*/

  // toggle mapping ------------------------------------------------------

  const toggleMapping = (typeModal) => {
    if (isMapping) {
      if (context.selectedRobot.ROS === 'ROS2') {
        cancelActions({ stopmapping: true }, context.selectedRobot.ROS)
      } else {
        cancelActions({ stopMapping: true }, context.selectedRobot.ROS)
      }
      context.actions.setSavingStatus(true)
      console.log(context.mappingCurrent, context.selected)
      if (context.settings.fmsConnection) context.actions.setSelected({ map: { name: context.mappingCurrent.name, robotId: context.robotInfo._id } })
      else fetchMapInformation()
      context.actions.setMappingCurrent(null)
      setModalData(null)
      if (context.settings.fmsConnection) exportMaps()
      setHand(false)
      setTypeMap(false)
      // console.log("preparing to shut down map subscriber")
      if (window.mapSubscriber) {
        // console.log("shutting down map subscriber")
        window.mapSubscriber.shutdown()
      }
    } else {
      context.actions.setKonvaPoints([])
      context.actions.setKonvaEdges([])
      context.actions.setKonvaAreas([])
      context.actions.setChanges([])
      context.actions.setUndone([])
      openModal(typeModal)
      setTypeMap(typeModal)
    }

    setIsMapping(!isMapping)
  }

  // delete map ----------------------------------------------------------

  const deleteMap = async () => {

    const indx = context.maps.findIndex(v => v.name === context.selected.map?.name && v.robotId === context.robotInfo._id)
    if (indx < 0) {
      setModal(false)
      return false
    }

    console.log("ExportMaps - Update map: name before filtered : ", context.maps[indx])

    let filteredMap = context.maps[indx]
    console.log(filteredMap)
    delete filteredMap.active
    filteredMap.deleted = true
    filteredMap.syncFMS = false
    console.log("updating FMS with map", filteredMap)

    console.log("ExportMaps - Update map: map Object to update : ", filteredMap)

    let updateResult = await api.updateMap(filteredMap)
    if (updateResult) context.actions.setMessage({ message: "Resultado do mapa atualizado no FMS", type: "success" })
    else context.actions.setMessage({ message: "Mapa ou pontos não atualizados no FMS", type: "error" })
    if (context.diagnosticSwitch)
      c("ExportMaps - Update map: Map update on FMS result: ", updateResult)

    const maps = [...context.maps]
    maps.splice(indx, 1)
    context.actions.setMaps(maps)

    //context.actions.setSelected({ map: context.maps[0]?.name ? context.maps[0].name  :  null})
    context.actions.setSelected({ map: { name: "Select map" } })
    context.actions.setKonvaPoints([])
    context.actions.setKonvaEdges([])
    context.actions.setKonvaAreas([])
    context.actions.setChanges([])
    context.actions.setUndone([])
    setModal(false)
  }

  // Processing image callback --------------------------------------------

  /*const callback = (msg, canvas, context, firstRun) => {
    OccupancyGridVisualizer.drawMap(msg, canvas)
    let header = msg.header
    canvas.needsUpdate = true
    let width = msg.info.width * msg.info.resolution
    let height = msg.info.height * msg.info.resolution
    let scale = [width, height, 1]
    let position = [(msg.info.origin.position.x + width / 2), (msg.info.origin.position.y + height / 2), 0]
    console.log(canvas)
    context.actions.setMapFeed({ canvas: canvas, header: header, scale: scale, position: position })
    context.actions.setMapOrientation({ x: parseFloat(msg.info.origin.position.x + width / 2).toFixed(4), y: parseFloat(msg.info.origin.position.y + width / 2).toFixed(4) })

    // update map resolution and origin on first run for the selected map
    if (firstRun && msg.info.resolution && msg.info.origin) {
      const currentMap = context.maps.find(m => m.name === context.selected.map?.name && m.robotId === context.robotInfo._id)
      // console.log("updating map resolution", firstRun)
      if (!currentMap) return false
      currentMap.resolution = msg.info.resolution
      currentMap.origin = msg.info.origin
      let newMaps = [...context.maps]
      newMaps[context.mapIndex] = currentMap
      context.actions.setMaps(newMaps)

      // update FMS
      /* if (context.settings.fmsConnection) {
          api.updateMap(currentMap)
        }
    }
  }*/

  const callback = (msg, canvas, context, firstRun) => {

  }

  // Subscribe to map feed once on load ----------------------------------------------------------

  useEffect(() => {
    // if (canvas) console.log("running map subscriber once")
    //if (canvas) ROS.subscribeMapOnce(callback, canvas, context, true)
    //  if (context.selected.map === null || context.selected.map === undefined) context.actions.setSelected({map: { name: "Select map"}})
  }, [canvas, context.selected.map])

  // select last map used for this robot ----------------------------------------------------------

  const fetchMaps = async () => {
    if (context.settings.fmsConnection) {
      let res

      res = await api.fetchMaps({ syncFMS: true })

      console.log('MAPS:', res)

      if (res?.data) context.actions.setMaps(res?.data)
    }
  }

  const fetchMapInformation = async () => {
    console.log('fetching map name from txt...')

    fetch('http://' + context.selectedRobot.ip + '/map.txt?nocache=' + Date.now())
      .then(response => {
        response.text()
          .then(text => {
            console.log('map name is ', text)
            let noSpacing = text.replace(/\n/g, '')
            context.actions.setSelected({ ...context.selected, map: { name: noSpacing } })
          })
      })
      .catch(error => {
        console.error(error)
      })

    console.log('fetching nav info from xml...')
    let points, edges, areas, no_go

    fetch('http://' + context.selectedRobot.ip + '/navInfo.xml?nocache=' + Date.now())
      .then(response => {
        response.text()
          .then(info => {
            const xmlDoc = new DOMParser().parseFromString(info, 'text/xml')

            const navPoints = [...xmlDoc.querySelectorAll('navPoints > *')].map((point) => ({
              counter: 'pn-' + point.querySelector('ID')?.textContent.trim(),
              name: [point.querySelector('ID_FMS')?.textContent.trim()],
              point: { x: parseFloat(point.querySelector('X')?.textContent.trim()), y: parseFloat(point.querySelector('Y')?.textContent.trim()) }
            }))

            console.log('points are ', navPoints)

            let counter = 0

            const navPaths = [...xmlDoc.querySelectorAll('navEdges > *')].map((path) => {
              const navEdges = [...path.getElementsByTagName(`*`)].filter(node => node.nodeName.startsWith('navEdge')).map((edge, index) => {
                const id1 = edge.querySelector('ID1')?.textContent?.trim()
                const id2 = edge.querySelector('ID2')?.textContent?.trim()
                const avoidText = edge.querySelector('Avoid')?.textContent?.trim()

                console.log(`ID1: ${id1}, ID2: ${id2}, Avoid: ${avoidText}`)

                if (!id1 || !id2) {
                  return null
                }

                if (id1 !== id2) {
                  counter++
                  return {
                    avoid: avoidText === "0" ? false : true,
                    counter: 'ln-' + counter,
                    from: navPoints[Number(id1)]?.name?.[0] || "Unknown",
                    reversable: false,
                    to: navPoints[Number(id2)]?.name?.[0] || "Unknown"
                  };
                }

                return null;
              })

              let deleteNulls = navEdges.filter(function (el) {
                return el != null;
              });

              return deleteNulls
            })

            let arrayOfArrays = []
            let actualEdges = []

            navPaths.forEach((path) => {
              if (path.length !== 0) arrayOfArrays.push(path)
            })

            arrayOfArrays.forEach((edge) => {
              edge.forEach((e) => {
                actualEdges.push(e)
              })
            })


            let seen = new Object()

            actualEdges.forEach(edge => {
              let key = `${edge.from}-${edge.to}`
              let reverseKey = `${edge.to}-${edge.from}`

              if (seen[reverseKey]) {
                seen[reverseKey].reversable = true
                edge.reversable = true
              } else {
                edge.reversable = false
                seen[key] = edge
              }
            })

            let noDupes = Object.values(seen);
            points = navPoints
            console.log('edges are ', noDupes)
            edges = noDupes

            console.log('fetching areas from xml...')

            fetch('http://' + context.selectedRobot.ip + '/slowZones.xml?nocache=' + Date.now())
              .then(response => {
                response.text()
                  .then(info => {
                    const xmlDoc = new DOMParser().parseFromString(info, 'text/xml')

                    const navZones = [...xmlDoc.querySelectorAll('slowZone > *')].map((zone, i) => {
                      const zonePoints = [...xmlDoc.querySelectorAll(`Polygon${i} > *`)].map((point, j) => {
                        if (j > 3) return null
                        return {
                          counter: 'pz' + i + '-' + j,
                          point: { x: parseFloat(point.querySelector('X')?.textContent.trim()), y: parseFloat(point.querySelector('Y')?.textContent.trim()) }
                        }
                      })

                      let actualCorners = zonePoints.filter(function (el) {
                        return el != null;
                      });

                      return {
                        velocity: parseFloat(zone.querySelector('Velocity')?.textContent.trim()),
                        beep: zone.querySelector('Beep')?.textContent.trim() === 0 ? false : true,
                        name: zone.querySelector('Name')?.textContent.trim(),
                        polygon: actualCorners
                      }
                    })

                    console.log('areas are ', navZones)
                    areas = navZones
                    //context.actions.setSelected({ ...context.selected, map: { objects: info } })

                    console.log('fetching no go info from xml...')

                    fetch('http://' + context.selectedRobot.ip + '/no_go_Info.xml?nocache=' + Date.now())
                      .then(response => {
                        response.text()
                          .then(info => {
                            const xmlDoc = new DOMParser().parseFromString(info, 'text/xml')

                            const noGoZones = [...xmlDoc.querySelectorAll('nogoZone > *')].map((zone, i) => {
                              const zonePoints = [...xmlDoc.querySelectorAll(`Polygon${i} > *`)].map((point, j) => {
                                if (point.querySelector('X') && point.querySelector('Y')) {
                                  return {
                                    counter: 'pf-' + i + '-' + j,
                                    point: { x: parseFloat(point.querySelector('X')?.textContent.trim()), y: parseFloat(point.querySelector('Y')?.textContent.trim()) }
                                  }
                                } else return null
                              })

                              let actualCorners = zonePoints.filter(function (el) {
                                return el != null;
                              });

                              return {
                                polygon: actualCorners
                              }
                            })

                            console.log('no gos are ', noGoZones, context.mapObjects)
                            no_go = noGoZones
                            //context.actions.setSelected({ ...context.selected, map: { objects: info } })

                            console.log(points, edges, areas, no_go)
                            context.actions.setMapObjects({ points: points, edges: edges, areas: areas, no_go: no_go })
                          })
                      })
                      .catch(error => {
                        console.error(error)
                      })
                  })
              })
              .catch(error => {
                console.error(error)
              })
          })
      })
      .catch(error => {
        console.error(error)
      })
  }

  useEffect(() => {
    if (!isMapping) {
      if (context.settings.fmsConnection) {
        fetchMaps()

        console.log(context.maps, context.robotInfo?._id)

        let actualMaps = context.maps.map((m, i) => {
          //context.selectedRobot não tem ID para comparar ao m.robotId
          if (m.robotId === context.robotInfo?._id) {
            return m
          } else return null
        })

        console.log(actualMaps)

        let deleteNulls = actualMaps.filter(function (el) {
          return el != null;
        });

        console.log(deleteNulls, context.mapIndex)

        if (deleteNulls.length > 0) {
          console.log('fetching map name from txt...')

          fetch('http://' + context.selectedRobot.ip + '/map.txt?nocache=' + Date.now())
            .then(response => {
              response.text()
                .then(text => {
                  console.log('map name is ', text)
                  let noSpacing = text.replace(/\n/g, '')
                  let index = deleteNulls.findIndex(m => m.name === noSpacing)
                  if (index === -1) {
                    context.actions.setMessage({message: "Current map mismatch. Please select a map." , type: "error"})
                    context.actions.setSelected({ map: { name: "Select map" } })
                    return false
                  }
                  context.actions.setSelected({ ...context.selected, map: { name: noSpacing, robotId: context.robotInfo._id } })
                  context.actions.setHelpers({ ...context.helpers, newItem: true })
                  setIsMapping((context.mappingCurrent && context.mappingCurrent.name === deleteNulls[index].name) ? context.mappingCurrent?.mapping : false)
                  context.actions.setMapObjects(deleteNulls[index].objects ? deleteNulls[index].objects : {})

                  let maps = deleteNulls.map(m => m.robotId === context.robotInfo?._id && m.name === deleteNulls[index].name ?
                    ({ ...m, active: true })
                    : m.robotId === context.robotInfo?._id ?
                      ({ ...m, active: false })
                      :
                      (m))

                  console.log(maps)
                  context.actions.setMaps(maps)

                  if (~index) {
                    !deleteNulls[index]?.robotId && addRobotId(context.robotInfo?._id, index)
                  }

                  console.log(maps[index].name)

                  if (context.endOfMission) sendTaskToRobot({ actions: [{ id: "select-map", name: "select-map", value: maps[index].name }], id: "select-map", name: "select-map" }, context.selectedRobot.ROS)

                  console.log("init map index and selected", index, deleteNulls[index])
                  context.actions.setMapIndex(index)
                })
            })
            .catch(error => {
              console.error(error)
            })
        }
      } else {
        fetchMapInformation()
          .then(() => {
            console.log('yo', context.mapFeedFull)
            if (Object.keys(context.mapFeedFull).length > 0) {
              console.log('setting offline map...', context.mapObjects)
              context.actions.setMaps([{ name: context.selected?.map?.name, _id: 1, objects: context.mapObjects, link: '/maps/' + context.selected?.map?.name + '.png', origin: context.mapFeedFull.origin.position, resolution: context.mapFeedFull.resolution }])
            }
          })
      }
    }

    if (canvas) {
      //console.log("subscribing to map")
      window.mapSubscriber = ROS.subscribeMap(callback, canvas, context, false)
    }

  }, [context.robotInfo?._id])

  useEffect(() => {
    if (!context.settings.fmsConnection && !isMapping && (context.endOfMission || (context.lastMission !== 'map' && context.lastMission !== 'soft-map'))) {
      fetchMapInformation()
        .then(() => {
          console.log('yo', context.mapFeedFull)
          if (Object.keys(context.mapFeedFull).length > 0) {
            console.log('setting offline map...', context.mapObjects)
            context.actions.setMaps([{ name: context.selected?.map?.name, _id: 1, objects: context.mapObjects, link: '/maps/' + context.selected?.map?.name + '.png', origin: context.mapFeedFull.origin.position, resolution: context.mapFeedFull.resolution }])
          }
        })
    }
  }, [context.mapFeedFull])

  const addRobotId = (robotId, indexMap) => {

    if (robotId && indexMap) {
      let maps = [...context.maps]

      const newMap = { ...context.maps[indexMap], robotId: robotId }
      maps[context.mapIndex] = newMap

      context.actions.setMaps(maps)
    }

  }

  // select new tool ----------------------------------------------------------------------------

  const selectTool = (target) => {
    context.actions.setHelpers({ ...context.helpers, newItem: true })
    setModalData(null)
    const tool = target === '' ? null : context.drawTools.find(map => map._id === target)
    console.log("selecting tool", tool)
    if (tool) context.actions.setSelected({ tool: tool, connect: null })
  }

  // save area info -------------------------------------------------------------------------

  const saveAreaInfo = () => {
    setModal(false)
  }

  // validate area data (close objects) ----------------------------------------------------------------------------

  const validateArea = () => {

    let newObjects = { ...context.mapObjects }

    newObjects.areas && newObjects.areas.forEach((area, idx) => {
      if (Array.isArray(area.points) && area.points[0] !== area.points[area.points.length - 1])
        newObjects.areas[idx].points.push(area.points[0])
    })

    context.actions.setMapObjects(newObjects)
  }

  // undo -----------------------------------------------------------------------------------------------------
  const undo = () => {
    if (context.changes.length > 0) {
      context.actions.setKonvaPoints([...context.changes[context.changes.length - 1].old[0]])
      context.actions.setKonvaEdges([...context.changes[context.changes.length - 1].old[1]])
      context.actions.setKonvaAreas([...context.changes[context.changes.length - 1].old[2]])

      console.log(context.changes)
      let newChanges = [...context.changes]
      context.actions.setUndone([...context.undone, newChanges.pop()])

      context.actions.setChanges([...newChanges])

      context.actions.setSelector(false)
    }

    /*// remove point
    let newObjects = { ...context.mapObjects }
  
    if (context.selected.tool?._id === "points") {
  
      if (newObjects.points.length <= 0) return false
  
      // remove connected edges, if present
      let lastPoint = newObjects.points[newObjects.points.length - 1]
  
      if (newObjects.edges && modal === 'edges') {
        let newEdges = newObjects.edges.filter(edge => {
          //  console.log("finding edge", edge.from, edge.to, lastPoint?.name, lastPoint?.name.indexOf(edge.from), lastPoint?.name.indexOf(edge.to))
          if (lastPoint?.name.indexOf(edge.from) < 0 && lastPoint?.name.indexOf(edge.to) < 0) {
            return edge
          }
        })
  
        //console.log("undoing edges", newEdges, newObjects.edges, lastPoint)
        newObjects.edges = newEdges
      }
  
      // remove nav point
      if (newObjects.points.length > 0) newObjects.points.pop()
  
    } else { // remove non nav point
      if (newObjects[context.selected.tool?._id]?.length > 0) {
        if (newObjects[context.selected.tool?._id][(newObjects[context.selected.tool?._id].length - 1)].polygon.length > 1) {
          newObjects[context.selected.tool?._id][(newObjects[context.selected.tool?._id].length - 1)].polygon.pop() // pop point
        } else {
          newObjects[context.selected.tool?._id].pop() // pop area
          context.actions.setHelpers({ ...context.helpers, newItem: true })
        }
      }
    }
  
    context.actions.setMapObjects(newObjects)*/
  }

  const redo = () => {
    if (context.undone.length > 0) {
      context.actions.setKonvaPoints([...context.undone[context.undone.length - 1].new[0]])
      context.actions.setKonvaEdges([...context.undone[context.undone.length - 1].new[1]])
      context.actions.setKonvaAreas([...context.undone[context.undone.length - 1].new[2]])

      context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [context.undone[context.undone.length - 1].new[0], context.undone[context.undone.length - 1].new[1], context.undone[context.undone.length - 1].new[2]] }])

      console.log(context.undone)
      let newUndone = [...context.undone]
      newUndone.pop()

      context.actions.setUndone(newUndone)

      context.actions.setSelector(false)
    }
  }

  const validatePointName = (name) => {

    let names = []

    if (context.mapObjects?.points) {
      context.mapObjects.points.forEach(e => {
        names = names.concat(e.name)
      })
    }

    return names.includes(name)

  }
  const validatePoint = name => validatePointName(name)

  // connect points -------------------------------------------------------------------------------------

  const connect = (pointData) => {

    if (!modalData?.name) {
      context.actions.setMessage({ message: "Please add an ID", type: "error" })
      return false
    }

    setModal(null)
    console.log("connecting points from", pointData.name[0])
    context.actions.setSelected({ connect: { from: pointData.name[0] } })
  }

  // cancel connect ----------------------------------------------------------------------------------------

  const cancelConnect = () => {
    context.actions.setSelected({ connect: null })
    if (context.selected.tool._id !== "points") context.actions.setHelpers({ ...context.helpers, newItem: true })
  }

  // save edge -----------------------------------------------------------------------------------

  const saveEdge = () => {
    setModal(null)
    context.actions.setHelpers({ ...context.helpers, editing: false })
    context.actions.setSelected({ connect: null })
  }

  // delete object ---------------------------------------------------------------------------------------

  const deleteObject = () => {

    let newObjects = { ...context.mapObjects }, newEdges

    switch (context.selected.mapObject?.type) {
      case "points":
        let deletedPoint = newObjects.points[context.selected.mapObject.idx]
        newObjects.points.splice(context.selected.mapObject.idx, 1)
        // console.log("delete: new points", newObjects.points, context.selected.mapObject)

        // remove connected edges, if present
        newEdges = newObjects.edges.filter(edge => deletedPoint.name.indexOf(edge.from) < 0 && deletedPoint.name.indexOf(edge.to) < 0)

        newObjects.edges = newEdges
        // console.log("delete: new edges", newEdges, deletedPoint)
        break
      case "edges":
        newObjects.edges.splice(context.selected.mapObject.idx, 1)
        // console.log("delete: new edges", newObjects.edges, context.selected.mapObject)
        break
      case "areas":
        newObjects.areas.splice(context.selected.mapObject.idx, 1)
        // console.log("delete: new areas", newObjects.areas, context.selected.mapObject)
        break
      default:
    }

    context.actions.setSelected({ mapObject: null, connect: null })
    setModalData(null)
    context.actions.setMapObjects(newObjects)
    context.actions.setHelpers({ ...context.helpers, editing: false })
    setModal(null)
  }

  //-------------------------------

  const toggleAutoSave = () => {
    if (autoSave) {
      setAutoSave(false)
    } else {
      setAutoSave(true)
    }
  }

  //-------------------------------

  const tracePolygon = (start, visitedEdges, adjacencyList) => {
    let polygon = []
    let current = start

    while (1) {
      polygon.push(current)
      let neighbors = adjacencyList[current]

      let next = neighbors.find(neighbor => !visitedEdges.has(edgeKey(current, neighbor)))

      if (!next) break

      visitedEdges.add(edgeKey(current, next))
      visitedEdges.add(edgeKey(next, current))

      current = next

      if (current === start) {
        polygon.push(current)
        break
      }
    }

    return polygon
  }

  const edgeKey = (a, b) => {
    return a + '-' + b
  }

  // modal toggling -------------------------------------------------------------------------------

  let modalTitle, modalButtonLabel, modalButtonAction, modalComponent

  switch (modal) {
    case "reset": {
      if (context.selected.map) {
        modalTitle = "Reset Items"
        modalButtonLabel = "Reset"
        modalButtonAction = resetMap
        modalComponent = <ModalReset />
      } else {
        context.actions.setMessage({ message: "Select a map first", type: "error" })
        closeModal()
      }
      break
    }
    case "areas": {
      modalTitle = "Area"
      modalButtonLabel = "Save"
      modalButtonAction = savePoint
      modalComponent = <ModalArea velocity={modalData?.velocity} beep={modalData?.beep} update={updateModalData} />
      break
    }
    case "map": {
      modalTitle = "Map Name"
      modalButtonLabel = "Save"
      modalButtonAction = saveMap
      modalComponent = <ModalMap mapName={modalData?.mapName} update={updateModalData} />
      break
    }
    case "soft-map": {
      saveMapImprove()
      break
    }
    case "delete": {
      modalTitle = "Delete Map"
      modalButtonLabel = "Yes"
      modalButtonAction = deleteMap
      modalComponent = <ModalDelete mapName={context.selected.map?.name} />
      break
    }
    case "points": {
      modalTitle = "Point"
      modalButtonLabel = "Save"
      modalButtonAction = savePoint
      modalComponent = <ModalPoint pointData={modalData} update={updateModalData} connect={connect} validatePointName={validatePoint} />
      break
    }
    case "location": {
      modalTitle = "Point"
      modalButtonLabel = "Save"
      modalButtonAction = savePoint
      modalComponent = <ModalPoint pointData={modalData} update={updateModalData} connect={connect} validatePointName={validatePoint} />
      break
    }
    case "edges": {
      modalTitle = "Edge"
      modalButtonLabel = "Save"
      modalButtonAction = saveEdge
      //("detected edge modal")
      modalComponent = <ModalEdge edgeData={modalData} update={updateModalData} />
      break
    }
    default:
  }

  // helpers ------------------------------------------------------------------------------------

  let tool = context.selected.tool?._id

  return (
    <>

      {/* Top Actions */}

      <div className="mb-5">
        <span>
          {context.settings.fmsConnection &&
            <div className="select">
              <select className="select mb-2 mr-2" onChange={selectMap} value={context.selected.map?.name} style={{ minHeight: "2.5rem" }} disabled={isMapping || context.loadingMap || !context.endOfMission} >
                <option value='Select map' disabled>Select map</option>
                {context.maps.map((m, i) =>
                  m.robotId === context.robotInfo?._id &&
                  <option key={i} value={m?.name}>
                    {m?.name?.length >= 15 ? m?.name?.slice(0, 12) + "..." : m?.name?.slice(0, 14)}
                  </option>
                )}
              </select>
            </div>
          }

          {!context.settings.fmsConnection && context.selected.map && !isMapping &&
            <div className="column">
              <p className="pt-2">
                Selected map: {context.selected.map.name}
              </p>
            </div>
          }

          {!context.settings.fmsConnection && context.selected.map && isMapping &&
            <div className="column">
              <p className="pt-2">
                Currently mapping to: {modalData?.mapName}
              </p>
            </div>
          }

          {!isMapping && !context.savingStatus ? (
            <>
              <button disabled={!context.endOfMission} className="button is-primary mr-2" onClick={() => toggleMapping("map")}>
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faMapMarked} className="is-small mr-1" />
                </span>
                {orientation &&
                  <span className="is-size-7" >New Map</span>
                }
              </button>

              <button disabled={!context.endOfMission} className={context.selected.map && context.selected.map.name && (context.selected.map.name !== "Select map") ? "button is-primary is-outlined mr-2" : "button is-hidden"} onClick={() => toggleMapping("soft-map")}>
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faCirclePlus} className="is-small" />
                </span>
                {orientation &&
                  <span className="is-size-7" >Improve Map</span>
                }
              </button>

              <button
                disabled={!context.endOfMission}
                className={context.selected.map && context.selected.map.name && (context.selected.map.name !== "Select map") ? "button is-danger " : "button is-hidden"}
                onClick={() => openModal("delete")}
              >
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faTrash} className="is-small" />
                </span>
                {orientation &&
                  <span className="is-size-7" >Delete Map</span>
                }
              </button>

              {context.settings.fmsConnection &&
                <button disabled={!context.endOfMission} className={
                  autoSave
                    ? "button is-success ml-2"
                    : "button has-background-light is-active ml-2"
                } onClick={toggleAutoSave} style={{ float: 'right' }}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faSave} className={
                      autoSave
                        ? "is-small mr-1 fa-spin"
                        : "is-small mr-1"
                    } />
                  </span>
                  <span className="is-size-7">Auto Sync {autoSave ? 'On' : 'Off'}</span>
                </button>
              }

              {context.settings.fmsConnection && !autoSave &&
                <button disabled={!context.endOfMission} className="button is-warning is-light ml-2" onClick={exportMaps} onTouchEnd={exportMaps} style={{ float: 'right' }}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faRetweet} className="is-small mr-1" />
                  </span>
                  <span className="is-size-7">Sync to FMS</span>
                </button>
              }
            </>
          ) : (
            <>
              {context.savingStatus ? (
                <button className="button is-danger mr-2" disabled>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faSave} className="fas fa-pulse is-small" />
                  </span>
                  {orientation &&
                    <span className="is-size-7" > Saving </span>
                  }
                </button>
              ) : (
                <button disabled={!context.endOfMission && !(context.lastMission === 'map' || context.lastMission === 'soft-map')} className="button is-danger mr-2" onClick={() => toggleMapping("map")}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faCheck} className="is-small" />
                  </span>
                  {orientation &&
                    <span className="is-size-7" > Stop </span>
                  }
                </button>
              )}

            </>
          )
          }
        </span>

      </div>

      {/* Joystick */}

      {(isMapping && modal !== "map" && !context.modalState.disconnect && !context.modalState.configuration) &&
        <div className="column has-text-white-bis">

          {/* <div className="columns is-centered">
            <div className="column has-background-info-light is-narrow">
              <button className="button is-primary" onClick={handSelected}>
                <span className="icon is-small">
                  <i className="material-icons-round">{!hand ? "pan_tool" : "pan_tool"}</i>
                </span>
                <span>{!hand ? "Right" : "Left"}</span>
              </button>
            </div>
          </div> */}

          <Joystick orientation={orientation} />
        </div>
      }

      {/* Map */}

      <div className="has-background-grey" style={{ width: "100%", height: "36rem", position: "relative" }} id='canvas-id' ref={canvasRef} >

        {/*<canvas id='canvas-id' ref={canvasRef}>*/}
        <Suspense fallback={null}>
          <Map
            canvasRef={canvasRef}
            openModal={openModal}
            modalData={(modal === "nav" || modal === "area" || modal === "point") && modalData}
            context={context}
            updateCanvas={(c) => setCanvas(c)}
          />
        </Suspense>
        {/*</canvas>*/}

        {/* Tools */}

        {!context.loadingMap &&
          <div id="tools" style={{ position: "absolute", top: "1rem", left: "1rem" }}>
            <button disabled={!context.endOfMission} className={context.selected.tool?._id === 'select' ? "button is-link mr-2" : "button is-outlined mr-2"} onClick={() => selectTool('select')}>
              <FontAwesomeIcon icon={faArrowPointer} className="is-small mr-2" />
              <span className="is-size-7">Select</span>
            </button>

            <button disabled={!context.endOfMission} className={context.selected.tool?._id === 'points' ? "button is-link mr-2" : "button is-outlined mr-2"} onClick={() => selectTool('points')}>
              <FontAwesomeIcon icon={faLocationArrow} className="is-small mr-2" />
              <span className="is-size-7">Route</span>
            </button>

            <button disabled={!context.endOfMission} className={context.selected.tool?._id === 'areas' ? "button is-link mr-2" : "button is-outlined mr-2"} onClick={() => selectTool('areas')}>
              <FontAwesomeIcon icon={faVectorSquare} className="is-small mr-2" />
              <span className="is-size-7">Zone</span>
            </button>

            <button className={context.selected.tool?._id === 'location' ? "button has-background-warning mr-2" : "button is-outlined mr-2"} onClick={() => locateRobot()} disabled={tool === 'select' || tool === 'no_go' || tool === 'areas' || !context.endOfMission} >
              <FontAwesomeIcon icon={faMapPin} className="is-small mr-2" />
              <span className="is-size-7">Here</span>
            </button>

            {context.selected.connect &&
              <button disabled={!context.endOfMission} className="button is-link is-focused" onClick={cancelConnect}>
                Cancel Connect
              </button>
            }

          </div>
        }

        {/*Loading map */}

        {context.loadingMap &&

          <div id="tools" style={{ position: "absolute", top: "50%", width: "100%", textAlign: "center" }}>
            <button className="button is-primary mr-2" disabled>
              <span className="icon is-small">
                <FontAwesomeIcon icon={faSpinner} className="fas fa-pulse is-small" />
              </span>
              {orientation &&
                <span className="is-size-7" > Loading </span>
              }
            </button>
          </div>
        }

        {/* Actions */}

        {!context.loadingMap &&
          <div id="actions" style={{ position: "absolute", bottom: "1rem", left: "1rem" }}>
            {(!modal) && context.undone.length > 0 &&
              <span className="is-pulled-right" style={{ marginRight: "0.5rem" }}>
                <button disabled={!context.endOfMission} className="button is-success is-outlined" onClick={redo}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faShare} className="is-small mr-1" />
                  </span>
                  {orientation &&
                    <span className="is-size-7">Redo</span>
                  }
                </button>
              </span>
            }

            {(!modal) && context.changes.length > 0 &&
              <span className="is-pulled-right" style={{ marginRight: "0.5rem" }}>
                <button disabled={!context.endOfMission} className="button is-danger is-outlined" onClick={undo}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faReply} className="is-small mr-1" />
                  </span>
                  {orientation &&
                    <span className="is-size-7">Undo</span>
                  }
                </button>
              </span>
            }

            <button disabled={!context.endOfMission} className="button is-success" onClick={save} style={{ marginRight: "0.5rem" }}>
              <span className="icon is-small">
                <FontAwesomeIcon icon={faSave} className="is-small" />
              </span>
              {orientation &&
                <span className="is-size-7">Send to Robot</span>
              }
            </button>

            <button disabled={!context.endOfMission} className="button is-danger" onClick={() => openModal("reset")} style={{ marginRight: "0.5rem" }}>
              <span className="icon is-small">
                <FontAwesomeIcon icon={faUndo} className="is-small mr-1" />
              </span>
              {orientation &&
                <span className="is-size-7 has-text-white">Clear All</span>
              }
            </button>
          </div>
        }
      </div>


      {/* Message */}

      <ShowMessage />

      {/* Modal */}

      <div id="modal" className={modal ? "modal is-active" : "modal"} ref={modalRef}>
        <div className="modal-background"></div>
        <div className="modal-card">

          <header className="modal-card-head">
            <p className="modal-card-title">
              {modalTitle}
            </p>
            <button disabled={!context.endOfMission} className="delete" onClick={closeModal} aria-label="close"></button>
          </header>

          <section className="modal-card-body">

            {modal && modalComponent}

            <ShowMessage />

          </section>

          <footer className="modal-card-foot">
            {modalButtonLabel !== 'Reset' &&
              <button disabled={!context.endOfMission} className="button is-success" onClick={modalButtonAction}>
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faSave} className="is-small" />
                </span>
                <span>
                  {modalButtonLabel}
                </span>
              </button>
            }

            {modalButtonLabel === 'Reset' &&
              <button disabled={!context.endOfMission} className="button is-danger" onClick={modalButtonAction}>
                <span className="icon is-small">
                  <FontAwesomeIcon icon={faUndo} className="is-small" />
                </span>
                <span>
                  {modalButtonLabel}
                </span>
              </button>
            }

            {context.helpers.editing &&
              <button disabled={!context.endOfMission} className="button is-danger" onClick={deleteObject} style={{ marginRight: "0.5rem" }}>
                Delete
              </button>
            }

            <button disabled={!context.endOfMission} className="button" onClick={closeModal}>
              Cancel
            </button>

          </footer>

        </div>
      </div>
    </>
  )
}
